import { useFormContext } from 'react-hook-form';
import { InsightSummaryFormData } from '../../hooks/useInsightSummaryForm';
import Title from './Title';
import Description from './Description';

type InsightSummaryFormDetailsProps = {
  edit: boolean;
};

function InsightSummaryFormDetails({ edit }: InsightSummaryFormDetailsProps) {
  const {} = useFormContext<InsightSummaryFormData>();

  return (
    <>
      <Title />
      <Description edit={edit} />
    </>
  );
}

export default InsightSummaryFormDetails;
